<h1>{{ 'static-content-become-partner.text.title' | translate }}</h1>
<div>{{ 'static-content-become-partner.text.description' | translate }}</div>

<lib-spacer></lib-spacer>

<button
  mat-flat-button
  color="secondary"
  (click)="navigateToPartnerLandingPage()"
>
  {{ 'static-content-become-partner.buttons.be-partner' | translate }}
</button>
